var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"guide",style:('padding: 5px ' + _vm.item.lrEdge.val + 'px;' +
        'margin-top:' + _vm.item.mbConfig.val +'px;')},[_c('div',{staticClass:"line",style:('border-bottom: ' + _vm.item.heightConfig.val + 'px ' + _vm.item.lineStyle.list[_vm.item.lineStyle.type].style + '' + _vm.item.lineColor.color[0].item)})])
}
var staticRenderFns = []

export { render, staticRenderFns }